<!--
  - Copyright (c) 2022 by 安徽网才信息技术股份有限公司
  -
  - 除非事先获得版权所有人的许可, 禁止以下几项行为:
  - 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
  - 2. 向第三方透露任何与该软件相关的源代码或技术文档。
  - 3. 更改或删除软件或源码中的版权声明。
  -
  -->

<template>
    <div>
        <div v-if="$config.wcAgents.includes($store.state.agent)" class="m_banner_01" :style="{background:'url(' + bgPic + ') no-repeat center center'}">
            <div class="fz_sty" v-html="detail.showName"></div>
        </div>
        <div class="m-box clearfix">
            <div class="m-crumb pro">
                <span class="crumb-span">网上报名</span> <span class="crumb-span pad-lr-8">/</span>
                <a href="" class="crumb-link">项目详情</a>
            </div>
            <div v-if="detail.entrance === 1" class="box">
                <div class="w1080 mar_auto">
                    <div class="mt20 df jcsb">
                        <img src="@/assets/images/icon_inlet_01.png" class="cp" width="520" height="100" alt="" @click="handleRecruitment('sz')" />
                        <img src="@/assets/images/icon_inlet_02.png" class="cp" width="520" height="100" alt="" @click="handleRecruitment('xz')" />
                    </div>
                </div>
            </div>
            <div class="pro-title">
                基本信息
            </div>
            <div class="m-probase">
                <i class="ic ictop"></i> <i class="ic icbottom"></i>
                <div class="title">
                    {{ detail.name }}
                </div>
                <div>
                    <div class="pro-text info-introduction">
                        {{ textIntroduction }}
                    </div>
                    <span v-if="detail.introduction.length > 240" class="pro-link" style="cursor: pointer;" @click="showAll = !showAll">
                        {{ textTag }} <i class="ic" :class="textClass"></i>
                    </span>
                    <span v-else class="pro-link"></span>
                </div>
                <div class="pro-text" style="min-height: 75px;">
                    <div v-if="detail.sponsor">
                        招聘单位：{{ detail.sponsor }}<br />
                        <br />
                    </div>
                    <div v-if="detail.sponsorPhone">
                        联系电话：{{ detail.sponsorPhone }}
                    </div>
                </div>
            </div>
            <div class="pro-title">
                公告
            </div>
            <ul class="m-pronotice">
                <li v-for="(noticeList, index) in detail.projectNotice" :key="index" class="clearfix">
                    <div class="ptitle">
                        <i class="icon iconfont" :class="classSelect(index)" style="font-size: 18px;vertical-align: middle;"></i> {{ index }}
                    </div>
                    <div class="pro-nright">
                        <router-link
                            v-for="(notice, idx) in noticeList" :key="idx"
                            class="pb-4"
                            :class="idx === 0 ? 'pb-4' : ''"
                            :to="{name: 'notice:detail', query: {id: notice.id}}"
                        >
                            <div class="ptext ellipsis">
                                <el-tooltip
                                    class="item"
                                    effect="light"
                                    popper-class="tooltip-wrap"
                                    :content="notice.title"
                                    placement="bottom-end"
                                    :open-delay="1000"
                                >
                                    <span>{{ notice.title }}</span>
                                </el-tooltip>
                            </div>
                            <div class="pdate">
                                {{ notice.onlineAt }}
                            </div>
                        </router-link>
                    </div>
                </li>
            </ul>
            <div v-if="detail.id !== 85" class="pro-title">
                项目信息
            </div>
            <div v-if="detail.id !== 85" class="m-proinfo">
                <ul class="clearfix">
                    <li :style="detail.recruitNum ? '' : 'width: 33.3%;'">
                        <div class="intitle">
                            招聘职位数
                        </div>
                        <div class="num">
                            {{ detail.jobNum }}
                        </div>
                    </li>
                    <li v-if="detail.recruitNum">
                        <div class="intitle">
                            招聘人数
                        </div>
                        <div class="num">
                            {{ detail.recruitNum }}
                        </div>
                    </li>
                    <li :style="detail.recruitNum ? '' : 'width: 33.3%;'">
                        <div class="intitle">
                            报名时间
                        </div>
                        <div class="date">
                            {{ detail.applyStartTime }}<br />
                            {{ detail.applyEndTime }}
                        </div>
                    </li>
                    <li v-if="!$config.ycAgents.includes($store.state.agent)" :style="detail.recruitNum ? '' : 'width: 33.3%;'">
                        <div class="intitle">
                            是否收费
                        </div>
                        <div class="text">
                            {{ isCharge }}
                        </div>
                    </li>
                </ul>
            </div>

            <div v-if="detail.entrance === 0">
                <div ref="jobList" class="pro-title">
                    招聘信息
                </div>

                <div class="sticky-filter">
                    <div v-if="detail.jobScreening === 1">
                        <label class="label-name">招聘单位：</label>
                        <el-select
                            v-model="ownerUnit"
                            style="width: 300px; color: #1a202c;"
                            class="ap-select"
                            clearable
                            placeholder="点击选择所属单位"
                            @change="getProjectDetail"
                            @clear="getProjectDetail"
                        >
                            <el-option v-for="(item, index) in ownerUnits" :key="index" :label="item" :value="item" />
                        </el-select>
                        <label v-if="ownerDeptList.length > 0" class="label-name">招聘部门：</label>
                        <el-select
                            v-if="ownerDeptList.length > 0"
                            v-model="ownerDept"
                            style="width: 300px; color: #1a202c;margin-left: 10px;"
                            class="ap-select"
                            clearable
                            placeholder="点击选择所属部门"
                            @change="getProjectDetail"
                            @clear="getProjectDetail"
                        >
                            <el-option v-for="(item, index) in ownerDeptList" :key="index" :label="item" :value="item" />
                        </el-select>
                        <!--  查看按钮  -->
                        <div class="btn-box">
                            <div class="btn-more" @click="getProjectDetail">
                                查询
                            </div>
                        </div>
                    </div>
                    <div v-if="detail.jobScreening === 2 || detail.jobScreening === 3" class="mt35 m_area_block_2">
                        <div v-if="detail.jobScreening === 2 || detail.jobScreening === 3" class="">
                            <div class="pb5 fz16 lh24 fwb cor_3C4">
                                招聘单位
                            </div>
                            <ul class="fl_dib m_screen_list">
                                <li
                                    v-for="(unit, index) in ownerUnits"
                                    :key="index" :class="unit === ownerUnit ? 'current screen_item' : 'screen_item'"
                                    @click="handleClickUnit(unit)"
                                >
                                    {{ unit }}
                                </li>
                            </ul>
                        </div>
                        <div v-if="detail.jobScreening === 3 && ownerDeptList.length" class="mt15">
                            <div class="pb5 fz16 lh24 fwb cor_3C4">
                                招聘部门
                            </div>
                            <ul class="fl_dib m_screen_list">
                                <li
                                    v-for="(dept, index) in ownerDeptList"
                                    :key="index" :class="dept === ownerDept ? 'current screen_item' : 'screen_item'"
                                    @click="handleClickDept(dept)"
                                >
                                    {{ dept }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- 职位列表开始 -->
                <div v-if="detail.displayMode === 1">
                    <div v-for="(job, index) in detail.projectJob" :key="job.id" class="m-projob">
                        <div class="clearfix">
                            <div class="fl">
                                <div class="job-title">
                                    （{{ job.jobCode }}）{{ job.jobName }}
                                </div>
                                <div class="job-cond clearfix">
                                    <div v-if="job.address || job.workExp || job.needEdu || job.jobNum" class="fl mr-24">
                                        <i class="ic ic-loac"></i>
                                        {{ job.address }}
                                        {{ job.workExp }}
                                        {{ job.needEdu }}
                                        <span v-if="job.jobNum">招{{ job.jobNum }}人</span>
                                    </div>
                                    <div class="fl">
                                        <i class="ic ic-com"></i>
                                        {{ job.ownerUnit }}
                                        {{ job.ownerDepartment ? '-' : '' }}
                                        {{ job.ownerDepartment }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="job.canApply === 1" class="fr text-right">
                                <div v-if="detail.stage === 1">
                                    <span v-if="detail.applicationJobId && detail.applicationJobId !== job.id" class="btn-send end">立即报名</span>
                                    <span v-else-if="detail.applicationJobId === job.id" class="btn-send" @click="handleApply(queryParam.id, job.id)">查看结果</span>
                                    <span v-else class="btn-send" @click="handleApply(queryParam.id, job.id)">立即报名</span>
                                </div>
                                <div v-else>
                                    <span v-if="detail.applicationJobId === job.id" class="btn-send" @click="handleApply(queryParam.id, job.id)">查看结果</span>
                                    <span v-else class="btn-send" :class="detail.stage === 2 ? 'dis' : 'end'">{{ detail.stageName }}</span>
                                </div>
                            </div>
                            <div v-else class="fr text-right">
                                <div>
                                    <span v-if="detail.applicationJobId === job.id" class="btn-send" @click="handleApply(queryParam.id, job.id)">查看结果</span>
                                    <span v-else class="btn-send dis">停止报名</span>
                                </div>
                            </div>
                        </div>
                        <!-- 职位列表开始 -->
                        <!-- 职位详情开始 -->
                        <el-collapse-transition>
                            <div v-if="activeIndex === index" class="job-info">
                                <p class="desc">
                                    {{ job.desc }}
                                </p>
                                <h1 v-if="job.needMajor || job.needAge">
                                    其他要求：
                                </h1>
                                <p>
                                    <span v-if="job.needMajor">专业：{{ job.needMajor }}</span>
                                    <br v-if="job.needMajor" />
                                    <span v-if="job.needAge">年龄：{{ job.needAge }}</span>
                                </p>
                            </div>
                        </el-collapse-transition>
                        <!-- 职位详情结束 -->
                        <div class="center lh60" @click="handleDetail(index)">
                            <i class="icon iconfont icon-exam-down btn-more" :class="activeIndex === index ? 'icon iconfont icon-exam-up btn-more':''"></i>
                        </div>
                    </div>
                </div>

                <!-- 职位卡片开始 -->
                <div v-if="detail.displayMode === 2" class="box">
                    <div class="w1080 mar_auto">
                        <div class="pb30">
                            <ul class="m_recruitment_list fl_dib">
                                <li v-for="job in detail.projectJob" :key="job.id" class="recruitment_item">
                                    <div class="fz18 lh24 fwb cor_181 ell">
                                        （{{ job.jobCode }}）{{ job.jobName }}
                                    </div>
                                    <div class="mt15 m_area_block_1">
                                        <div class="df aic">
                                            <img src="@/assets/images/icon_dingwei.png" width="20px" height="20px" alt="" />
                                            <div class="ml5 fz14">
                                                <span v-if="job.address">{{ job.address }}·</span>
                                                <span v-if="job.workExp">{{ job.workExp }}·</span>
                                                <span v-if="job.needEdu">{{ job.needEdu }}·</span>
                                                <span v-if="job.jobNum">招{{ job.jobNum }}人</span>
                                            </div>
                                        </div>
                                        <div class="mt10 df aic">
                                            <img src="@/assets/images/icon_gongsi.png" width="20" height="20" alt="" />
                                            <div class="ml5 fz14">
                                                <span v-if="job.ownerUnit">{{ job.ownerUnit }}</span>
                                                <span v-if="job.ownerDepartment">-{{ job.ownerDepartment }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="job.needMajor || job.needAge" class="mt15">
                                        <div class="fz14 lh24 fwb cor_181">
                                            其他要求：
                                        </div>
                                        <div class="fz_h_ov_1">
                                            <div v-if="job.needMajor" class="">
                                                专业：{{ job.needMajor }}
                                            </div>
                                            <div v-if="job.needAge">
                                                年龄：{{ job.needAge }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt10">
                                        <div class="fz14 lh24 fwb cor_181">
                                            职位描述：
                                        </div>
                                        <div class="fz_h_ov_2" :style="!job.needMajor && !job.needAge ? 'height: 180px;' : ''">
                                            <div class="clamp_5">
                                                {{ job.desc }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="job.canApply === 1" class="mt20 tar">
                                        <div v-if="detail.stage === 1">
                                            <span v-if="detail.applicationJobId && detail.applicationJobId !== job.id" class="register_now_btn end">立即报名</span>
                                            <span v-else-if="detail.applicationJobId === job.id" class="register_now_btn" @click="handleApply(queryParam.id, job.id)">查看结果</span>
                                            <span v-else class="register_now_btn" @click="handleApply(queryParam.id, job.id)">立即报名</span>
                                        </div>
                                        <div v-else>
                                            <span v-if="detail.applicationJobId === job.id" class="register_now_btn" @click="handleApply(queryParam.id, job.id)">查看结果</span>
                                            <span v-else class="register_now_btn" :class="detail.stage === 2 ? 'dis' : 'end'">{{ detail.stageName }}</span>
                                        </div>
                                    </div>
                                    <div v-else class="mt20 tar">
                                        <div>
                                            <span v-if="detail.applicationJobId === job.id" class="register_now_btn" @click="handleApply(queryParam.id, job.id)">查看结果</span>
                                            <span v-else class="register_now_btn dis">停止报名</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {projectDetail, projectApplicationInfo, projectUnitInfo} from '@/api/project';
export default {
    name: 'ProjectDetail',
    data() {
        return {
            bgPic: require('@/assets/images/i_banner_01.png'),
            queryParam: {
                id: 0,
                code: ''
            },
            detail: {
                id: 0,
                name: '',
                showName: '',
                projectNumber: '',
                introduction: '',
                sponsor: '',
                sponsorPhone: '',
                isCharge: 1,
                applyStartTime: '',
                applyEndTime: '',
                jobNum: 0,
                recruitNum: 0,
                banner: '',
                displayMode: 1,
                jobScreening: 1,
                entrance: 0,
                projectNotice: [],
                projectJob: [],
                applicationJobId: 0,
                stage: 1,
                stageName: '立即报名'
            },
            activeIndex: 99,
            showAll: false,
            lineClamp: 3,
            isAgreed: true,
            organization: {},
            ownerUnit: '',
            ownerDept: '',
            ownerUnits: [],
            ownerDeptList: []
        };
    },
    computed: {
        isCharge() {
            return this.detail.isCharge === 1 ? '免费' : '收费';
        },
        textClass() {
            return this.showAll ? 'icup' : 'icdown';
        },
        textTag() {
            return this.showAll ? '收起' : '查看全部';
        },
        textIntroduction() {
            return this.showAll ? this.detail.introduction : this.detail.introduction.length > 240 ? this.detail.introduction.slice(0, 240) + '...' : this.detail.introduction;
        }
    },
    watch: {
        ownerUnit(val) {
            this.ownerDept = '';
            if (val in this.organization) {
                this.ownerDeptList =  this.organization[val];
            } else {
                this.ownerDeptList = [];
            }
        }
    },
    beforeCreate() {
        document.querySelector('body').setAttribute('style', 'background-color:#F7F8FA');
    },
    beforeDestroy() {
        // document.body.removeAttribute('style');
    },
    async created() {
        // 安徽烟草
        if (this.$config.ycAgents.includes(this.$store.state.agent)) {
            // 跳转到指定链接
            window.location.href = 'https://click.goodjobs.cn/2023/ahyc/1.html';
        }
        this.queryParam.id = this.$route.query.id ? this.$route.query.id : 0;
        this.queryParam.code = this.$route.query.code ? this.$route.query.code : '';
        if (this.queryParam.id) {
            const loadingInstance = this.$loading({
                fullscreen: true,
                text: '加载中',
                target: document.querySelector('.main')
            });
            await this.getProjectDetail();
            this.$nextTick(() => {
                loadingInstance.close();
            });
        }
        if (this.detail.entrance === 0) {
            this.scrollToJobList();
        }
        await this.getUnitInfo();
    },
    methods: {
        async getUnitInfo() {
            const { data } = await projectUnitInfo({
                projectId: this.queryParam.id
            });
            this.organization = data;
            this.ownerUnits = Object.keys(data);
        },
        scrollToJobList() {
            // 调用scrollIntoView方法实现滚动
            this.$nextTick(() => {
                this.$refs.jobList.scrollIntoView({ behavior: 'smooth' });
            });
        },
        async getProjectDetail() {
            const params = {
                id: this.queryParam.id,
                ownerUnit: this.ownerUnit,
                ownerDept: this.ownerDept
            };
            if (this.$route.query.search !== undefined) {
                Object.assign(params, {searchJobName: this.$route.query.search});
            }
            Object.assign(this.queryParam, params);
            const { data } = await projectDetail(this.queryParam);
            this.detail = data;
            if (this.detail.banner) {
                this.bgPic = this.detail.banner;
            }
        },
        async handleApply(projectId, jobId) {
            if (sessionStorage.getItem('isLogin')) {
                // 是否已经报名？
                const info = await projectApplicationInfo({
                    projectId: projectId,
                    jobId: jobId
                });
                if (info.data.id) {
                    await this.$router.push({
                        name: 'project:apply:result',
                        query: {
                            projectId: projectId,
                            jobId: jobId
                        }
                    });
                } else {
                    await this.$router.push({
                        name: 'project:apply:form:apply',
                        query: {
                            projectId: projectId,
                            jobId: jobId
                        }
                    });
                }
            } else {
                await this.$router.push({
                    name: 'project:apply:form:apply',
                    query: {
                        projectId: projectId,
                        jobId: jobId
                    }
                });
            }
        },
        handleDetail(index) {
            if (this.activeIndex === index) {
                this.activeIndex = 99;
            } else {
                this.activeIndex = index;
            }
        },
        autoSupplement(num, n) {
            let i = (num + '').length;
            while (i++ < n) num = '0' + num;
            return num;
        },
        classSelect(name) {
            switch (name) {
                case '招聘公告':
                    return 'icon-exam-notice';
                case '重要通知':
                    return 'icon-exam-inform';
                case '成绩公示':
                    return 'icon-exam-grade-publicity';
                case '拟录用公示':
                    return 'icon-exam-employ';
            }
        },
        handleClickUnit(unit) {
            this.ownerDept = '';
            this.ownerUnit = unit;
            this.getProjectDetail();
        },
        handleClickDept(dept) {
            this.ownerDept = dept;
            this.getProjectDetail();
        },
        handleRecruitment(type) {
            this.$router.push({
                name: 'project:recruitment:detail',
                query: {
                    id: this.queryParam.id,
                    type: type
                }
            });
        }
    }
};
</script>

<style scoped>
.ptext {
    width: 600px;
}
.btn-send {
    cursor: pointer;
}
.btn-send.end {
    background: #BCC4D0;
    color: #fff;
    cursor: auto;
}
.btn-send.dis {
    background: #7fa6d0;
    cursor: auto;
}

.register_now_btn {
    cursor: pointer;
}
.register_now_btn.end {
    background: #BCC4D0;
    color: #fff;
    cursor: auto;
}
.register_now_btn.dis {
    background: #7fa6d0;
    cursor: auto;
}

.desc {
    white-space: pre-line;
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: translateX(150px);
}
.info-introduction {
    white-space: pre-wrap;
}

.pro-title >>> .el-input__inner::placeholder {
    color: #1a202c;
}
/* 谷歌 */
.pro-title >>> .el-input__inner::-webkit-input-placeholder {
    color: #1a202c;
}
/* 火狐 */
.pro-title >>> .el-input__inner:-moz-placeholder {
    color: #1a202c;
}
/*ie*/
.pro-title >>> .el-input__inner:-ms-input-placeholder {
    color: #1a202c;
}
/* 滚动槽 */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
::-webkit-scrollbar-track {
    border-radius: 3px;
    background: rgba(0,0,0,0.06);
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.08);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgba(0,0,0,0.12);
    -webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.2);
}
</style>
<style lang="less">
.m-pronotice li .ptitle {
    color: var(--themeColor);
}
.m-proinfo li .num {
    color: var(--themeColor);
}
.m-proinfo li .date {
    color: var(--themeColor);
}
.m-proinfo li .text {
    color: var(--themeColor);
}
.m-projob .btn-send {
    background: var(--themeColor);
}
.center .btn-more {
    color: var(--themeColor);
    font-size: 24px;
    font-weight: bold;
}
.sticky-filter {
    position: sticky;
    top: 0; /* 根据需要调整 */
    background-color: white; /* 确保背景颜色与页面一致 */
    z-index: 1000; /* 确保元素在其他内容之上 */
    padding: 20px 40px; /* 根据需要调整 */
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1); /* 可选：添加阴影效果 */
}
.label-name {
    font-size: 14px;
    line-height: 24px;
    margin-left: 10px;
    display: inline-block;
    vertical-align: middle;
}
.btn-box {
    float: right;
    .btn-more {
        padding: 8px 35px;
        line-height: 24px;
        border-radius: 3px;
        background: var(--themeColor);
        color: #ffffff;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
    }
}
</style>
